import { useRouter } from 'next/router';
import logger from '@/lib/clientLogger';
import AuthService from '@/lib/AuthService';

export default function useNextPagePath(
  { nextPageURL }: { nextPageURL: string },
  hasBasePath?: boolean
) {
  const authService = AuthService();
  const router = useRouter();

  return async (authToken: string, oneTimeToken: string) => {
    const nextPage =
      nextPageURL.startsWith('http') || hasBasePath
        ? `${nextPageURL}`
        : `${router.basePath}${nextPageURL}`;

    logger.info({
      event: 'AuthDataCheckBeforeRedirect',
      source: 'useLoginRedirect',
      authToken: Boolean(authToken),
      oneTimeToken: Boolean(oneTimeToken),
    });

    await authService.redirectLogin(nextPage, authToken, oneTimeToken);
  };
}
